import { useRef } from "react";
import { Route, Routes, Navigate } from "react-router-dom";
import { Apply } from "../../Apply/Apply";
import Application from "../../Application/Application";
import { Relogin } from "../../Relogin/Relogin";
import { SecurePage } from "../../SecurePage/SecurePage";
import { Applications } from "../../Applications/Applications";
import NotAuthorized from "../../../MPP-Common-SPA/Errors/NotAuthorized";
import NotFound from "../../ErrorPages/NotFound";
import { ApplicationGenerator } from "../../../qa-automation/Test-Application-Generator/application-generator";

export const AppRouter = () => {
  const runInterceptor = useRef<boolean>(false);

  /* only run setup once */
  if (!runInterceptor.current) {
    // Assuming SetupInterceptors is a function that accepts a navigate function
    // SetupInterceptors(navigate);
    runInterceptor.current = true;
  }

  return (
    <Routes>
      <Route path="/" element={<Apply />} />
      <Route path="/home/" element={<Apply />} />
      <Route
        path="/applications"
        element={
          <SecurePage>
            <Applications />
          </SecurePage>
        }
      />
      <Route path="/apply/" element={<Apply />} />
      <Route
        path="/application/"
        element={
          <SecurePage>
            <Application />
          </SecurePage>
        }
      />
      {(process.env.REACT_APP_ENVIRONMENT === "test" ||
        process.env.REACT_APP_ENVIRONMENT === "dev" ||
        process.env.REACT_APP_ENVIRONMENT === "local") && (
        <>
          <Route path="/application-generator" element={<ApplicationGenerator />} />
        </>
      )}
      <Route path="/relogin/" element={<Relogin />} />
      <Route path="/401" element={<NotAuthorized />} />
      <Route path="/404" element={<NotFound />} />
      <Route path="*" element={<Navigate replace to="/404" />} />
    </Routes>
  );
};
